<ng-container *ngIf="isAstroPage; else notFound">
  <iframe
    *ngIf="iframeSrc"
    [src]="iframeSrc"
    class="astro-embed"
    title="Page content"
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation-by-user-activation"
  ></iframe>
</ng-container>

<ng-template #notFound>
  <div class="not-found-content">
    <img src="https://moveright.app/brand/logos/color-horizontal.svg" alt="Move Right" class="not-found-logo" />
    <h1>404</h1>
    <p class="not-found-subtitle">This move doesn't exist — but we'll help you find the right one.</p>
    <button pButton pRipple type="button" label="Back to Move Right" icon="pi pi-home" [routerLink]="['/']"></button>
  </div>
</ng-template>
